import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll to top utility - call this whenever navigating to a new page
export const scrollToTop = (behavior = 'smooth') => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: behavior
  });
};

// React component to auto-scroll on route change
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop('smooth');
  }, [pathname]);

  return null;
};